import React, { useState, useRef, useEffect } from "react";
import classes from "./Verify.module.css";
import RccgLogo from '../../Assets/rotating-logo.png';
import CalculatorIcon from '../../Assets/cal.png';
import GrowthIcon from '../../Assets/growth.png';
import TeamIcon from '../../Assets/team.png';
import MailIcon from '../../Assets/mail.png';
import RotatingLogo from '../../Assets/rotating-logo.png';
import { useNavigate } from "react-router-dom";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg";
import { Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../Components/Styles/API/API";

export default function Verify() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [bearer, setBearer] = useState('');
  const [data, setData] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [user, setUser] = useState('');
  const [admin, setAdmin] = useState("");



  const inputRefs = useRef([]);

  const handleChange = (element, index) => {
    const value = element.value;
    if (isNaN(value)) return;

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next input field if not the last input
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value2 = await localStorage.getItem('permissions');
      const value3 = await localStorage.getItem('admin');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value2 !== null) {
        setPermissions(value2);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };
 


  const handleContinue = async () => {
    setLoading(true);
    try {
      // console.log(data)
      // return;
      const otpCode = otp.join('');
      const response = await axios.post(`${BASE_URL}/verify-otp`,
        {
          token: otpCode
        },
        { headers }
      );


      navigate('/welcome');

    } catch (error) {
      let errorMessage = error.response?.data?.message || 'An error occurred';
      if (error.message === 'Network Error') {
        errorMessage = 'Connection error. Please check your internet connection.';
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isButtonDisabled) {
      handleContinue();
    }
  };

  const isButtonDisabled = !otp;




  return (
    <div className={classes.loginPage}>
      {/* LEFT SIDE (Hides on mobile) */}
      <div className={classes.leftSide}>
        <img src={RccgLogo} alt="Suite" className={classes.rlogo} />
        <h1 className={classes.topHeader}>Smart Accounting for Church Management</h1>
        <p className={classes.subHeader}>
          Streamline your finances with AI-powered tools designed
          specifically for Church Management
        </p>

        <div className={classes.featureBox}>
          <img src={CalculatorIcon} alt="Calculator" />
          <div>
            <p className={classes.cro_pt}>Complete Accounting Suite</p>
            <p className={classes.mind}>Everything you need to manage your finances</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={GrowthIcon} alt="Growth" />
          <div>
            <p className={classes.cro_pt}>Growth Analytics</p>
            <p className={classes.mind}>Track your business growth with detailed reports</p>
          </div>
        </div>

        <div className={classes.featureBox}>
          <img src={TeamIcon} alt="Team" />
          <div>
            <p className={classes.cro_pt}>Team Collaboration</p>
            <p className={classes.mind}>Work together with your team seamlessly</p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE LOGIN BOX */}
      <div className={classes.loginBox}>
        <img src={MailIcon} alt="mail" className={classes.mail} />
        <p className={classes.signTxt}>Verify Your Account</p>
        <p className={classes.signTxts}>A 6-digit code has been sent to
          <span className={classes.pone}> {localStorage.getItem("userEmail")}</span> </p>
    


      <div className={classes.verify}>
        {otp.map((data, index) => (
          <Form.Control
            key={index}
            type="text"
            name="otp"
            maxLength="1"
            className={classes.pay_rt}
            value={data}
            onKeyPress={handleKeyPress}
            onChange={e => handleChange(e.target, index)}
            onKeyDown={e => handleKeyDown(e, index)}
            ref={el => inputRefs.current[index] = el}
            autoFocus={index === 0}
            style={{ backgroundColor: '#fff', color: "#000" }}
          />
        ))}
      </div>

      <Button onClick={handleContinue}
        disabled={loading} variant="primary" className={classes.signInBtn}>Sign In</Button>
    </div>
   {
    loading && (
      <div className={classes.overlay}>
        <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
      </div>
    )
  }
    </div >
  );
}
